/*
 * @Description:
 * @Version: 1.0
 * @Author: changfeng
 * @Date: 2024-06-24 10:59:11
 * @LastEditors: changfeng
 * @LastEditTime: 2024-06-24 14:53:30
 */
export const DEFAULT_NAME = 'Umi Max';

export const HOME_URL = '/';
export const LOGIN_URL = '/login';
